/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/**
 * This file was auto-generated by `yarn generate-openapi-contracts`.
 * Do not make direct changes to the file.
 */

import { fetchAsJson, applyParameters } from '@modules/query/helpers'

import type { operations, components } from './types'

// GET /api/v1/serverless/clusters
// ts-unused-exports:disable-next-line
export const listClusters = async (args?: {
  queryParameters?: operations['listClusters']['parameters']['query']
}) =>
  fetchAsJson<Array<components['schemas']['Cluster']>>(
    applyParameters('/api/v1/serverless/clusters', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/clusters/{id}
// ts-unused-exports:disable-next-line
export const getCluster = async (args: {
  pathParameters: operations['getCluster']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['Cluster']>(
    applyParameters('/api/v1/serverless/clusters/{id}', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/regions
// ts-unused-exports:disable-next-line
export const listRegions = async (args?: {
  queryParameters?: operations['listRegions']['parameters']['query']
}) =>
  fetchAsJson<Array<components['schemas']['Region']>>(
    applyParameters('/api/v1/serverless/regions', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/regions/{id}
// ts-unused-exports:disable-next-line
export const getRegion = async (args: {
  pathParameters: operations['getRegion']['parameters']['path']
  queryParameters?: operations['getRegion']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['Region']>(
    applyParameters('/api/v1/serverless/regions/{id}', args),
    {
      method: 'GET',
    },
  )
